import React from 'react'
import styled from 'styled-components'
import { typography } from 'styled-system'

import { colors, ThemeColor } from 'utils/colors'

import Box from '../Box'
import Text, { TextProps } from '../Text'

type LinedTitleProps = Omit<TextProps, 'color' | 'children'> & {
  title: string
  color: ThemeColor
}
const LinedTitle: React.FC<LinedTitleProps> = ({ title, color, ...rest }) => (
  <Box display="flex" flexDirection="row" alignItems="center" width="100%">
    <Line color={color} />
    <TitleText color={color} ml={15} mr={15} {...rest}>
      {title}
    </TitleText>
    <Line color={color} />
  </Box>
)

const Line = styled.div<{ color: keyof typeof colors }>`
  height: 1px;
  width: 100%;
  background: ${({ color }) => colors[color]};
`

const TitleText = styled(Text)`
  ${typography}
  flex-shrink: 0;
`

export default LinedTitle
